<template>
  <div id="app">
    <!--img src="./assets/logo.png"></img-->
	<appHeader > </appHeader>
    <router-view/>
	<appFooter  > </appFooter>

  </div>
</template>

<script>
import appHeader from '@/components/appHeader'
import appFooter from '@/components/appFooter'  
 
export default {
  name: 'show',
  
  components:{
    appHeader,
	appFooter
    },
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  margin-top: -60px;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue